export class Megamenu {

	constructor( options ) {
		this.options = options
		this.menu = $( '.main-menu' )
		this.button_menu_icon = $( '.button-menu-icon' )
		this.button_menu = $( '.button-menu' )
        this.toggle_menu = $( '.toggle-menu' )
	}

	init() {
		const button_menu = this.button_menu
		const button_menu_icon = this.button_menu_icon
		const menu = this.menu

		button_menu.click( function ( event ) {
			event.preventDefault()
			button_menu_icon.toggleClass( 'active' )
			menu.toggle()
		} )

		this.toggle_menu.click( function ( event ) {
			event.preventDefault()
			event.stopPropagation()
			let parent = $( this ).parents( 'h3' )
			parent.toggleClass( 'open' )
		} )
	}

	hide() {
		this.menu.hide()
		this.button_menu_icon.removeClass( 'active' )
	}

}


// WEBPACK FOOTER //
// ./scripts/components/megamenu.js